import {urlForSpace} from "@src/utils/endpoints-urls";


export function urlForTimedShuttles(spaceId: string): string {
	return `${urlForSpace(spaceId)}/shuttle`;
}


export function urlForTimedShuttlesDefinitions(spaceId: string): string {
	return `${urlForTimedShuttles(spaceId)}`;
}


export function urlForTimedShuttlesDefinition(spaceId: string,
                                              definitionId: string): string {
	return `${urlForTimedShuttlesDefinitions(spaceId)}/${definitionId}`;
}


export function urlForTimedShuttlesOccurrencePolicies(spaceId: string,
                                                      definitionId: string): string {
	return `${urlForTimedShuttlesDefinition(spaceId, definitionId)}/occurrence-policies`;
}


export function urlForTimedShuttlesOccurrencePolicy(spaceId: string,
                                                    definitionId: string,
                                                    policyId: string): string {
	return `${urlForTimedShuttlesOccurrencePolicies(spaceId, definitionId)}/${policyId}`;
}


export function urlForTimedShuttlesHistory(spaceId: string,
										   date: string,
                                           pageNumber: number,
                                           pageSize: number): string {
	return `${urlForTimedShuttles(spaceId)}/history?date=${date}&page=${pageNumber}&size=${pageSize}`;
}

